import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from './truncate.pipe';
import { InvoiceablePipe } from './invoiceable.pipe';

const PIPES = [
  TruncatePipe,
  InvoiceablePipe,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    ...PIPES,
  ],
  providers: [
    ...PIPES,
  ],
  exports: [
    ...PIPES,
  ],
})
export class PipesModule {
  static forRoot(): ModuleWithProviders<PipesModule> {
    return {
      ngModule: PipesModule,
      providers: [
        ...PIPES,
      ],
    } as ModuleWithProviders<PipesModule>;
  }
}
